<template>
  <div id="users">
    <top-menu></top-menu>


    <b-table
        ref="usersTable"
        :items="USERS_DATA"
        :fields="fieldsLabel"
        striped
        bordered="bordered"
        head-variant="light"
        fixed
    >
      <template v-slot:cell()="data">
        <i class="t-cell cell-cursor"
           v-on:click.prevent="editCell(data.index, data.field.key)"
           :ref="'cell_view_' + data.index +'_'+ data.field.key"
           v-b-tooltip.hover :title="data.value"
        >
          {{ data.value }}
        </i>
        <b-input
            class="edit-cell"
            type="text"
            v-model="USERS_DATA[data.index][data.field.key]"
            v-on:change="changeCell(data.index, data.field.key)"
            :ref="'cell_edit_' + data.index +'_'+ data.field.key"
            style="display: none"
        ></b-input>
      </template>
      <template v-slot:cell(roles)="data">
        <i class="t-cell cell-cursor"
           v-on:click.prevent="editCell(data.index, data.field.key)"
           :ref="'cell_view_' + data.index +'_roles'"
           v-b-tooltip.hover :title="showRole(data.value)"
        >
          {{ showRole(data.value) }}
        </i>
        <div
            class="edit-cell"
            :ref="'cell_edit_' + data.index +'_roles'"
            style="display: none"
        >
          <b-form-select size="sm"
                         v-model="USERS_DATA[data.index]['roles']"
                         :options="ROLES" multiple required
          ></b-form-select>
          <b-button
              size="sm"
              class="m-1"
              v-on:click.prevent="changeCell(data.index, 'roles')"
          >({{ USERS_DATA[data.index]['roles'].length }}) Изменить
          </b-button>
        </div>
      </template>
      <template v-slot:cell(id)="data">
        <i class="t-cell">
          {{ data.value }}
        </i>
      </template>
      <template v-slot:cell(createdDatetime)="data">
        <i class="t-cell"
           v-b-tooltip.hover :title="data.value"
        >
          {{ data.value }}
        </i>
      </template>
      <template v-slot:cell(action)="data">
        <b-button
            v-if="data.index != 0"
            size="sm"
            v-on:click.prevent="userDelete(data.index, data.item.email)"
        >Удалить
        </b-button>
      </template>
    </b-table>

    <b-button
        variant="primary"
        class="float-right"
        v-on:click="SAVE()"
    >
      Сохранить
    </b-button>

    <div class="add-user">
      <b-button v-b-toggle.addUser variant="primary">
        Добавить пользователя
      </b-button>
      <b-collapse id="addUser" class="mt-2">
        <b-card>
          <b-form @submit.stop.prevent="addUser()" class="form-test">
            <b-container fluid>
              <b-row class="input-add-use">
                <b-col sm="2">
                  <label for="input-1">Имя:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="input-1" size="sm" v-model="name" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="input-add-use">
                <b-col sm="2">
                  <label for="input-2">Фамилия:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="input-2" size="sm" v-model="secondName" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="input-add-use">
                <b-col sm="2">
                  <label for="input-3">Должность:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="input-3" size="sm" v-model="position" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="input-add-use">
                <b-col sm="2">
                  <label for="input-6">Логин:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="input-6" size="sm" v-model="login" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="input-add-use">
                <b-col sm="2">
                  <label for="input-4">Email:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="input-4" size="sm" v-model="email" type="email" required></b-form-input>
                </b-col>
              </b-row>
              <b-row class="input-add-use">
                <b-col sm="2">
                  <label for="input-5">Группы:</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select id="input-5" size="sm" v-model="rolesVal" :options="ROLES" multiple
                                 required></b-form-select>
                  <span>{{ this.rolesVal.length }}</span>
                </b-col>
              </b-row>
              <b-row class="input-add-use">
                <b-button type="submit" variant="primary">Создать</b-button>
              </b-row>
            </b-container>
          </b-form>
        </b-card>
      </b-collapse>
    </div>

    <b-modal id="usersDuplicateError" hide-footer title="Ошибка">
      <p class="error-content"> Пользователь с такими данными уже существует - {{ duplicateValue }}</p>
      <b-button class="mt-3" variant="outline-error" block @click="$bvModal.hide('usersDuplicateError')">Ок</b-button>
    </b-modal>

  </div>
</template>

<script>
import topMenu from "@/components/users/components/topMenu";
import {createNamespacedHelpers} from "vuex";

const {mapGetters, mapActions} = createNamespacedHelpers('users/users');

export default {
  name: "users",
  data() {
    return {
      rolesVal: [],
      name: '',
      secondName: '',
      position: '',
      email: '',
      login: '',
      toggle: {},
      show: false,
      fieldsLabel: [
        {key: 'id', label: 'ID'},
        {key: 'name', label: 'Имя'},
        {key: 'secondName', label: 'Фамилия'},
        {key: 'position', label: 'Должность'},
        {key: 'login', label: 'Логин'},
        {key: 'password', label: 'Пароль'},
        {key: 'email', label: 'Емейл'},
        {key: 'createdDatetime', label: 'Дата обновления'},
        {key: 'roles', label: 'Группы'},
        {key: 'action', label: 'Действие'}
      ],
      duplicateValue: ''
    }
  },
  components: {
    topMenu
  },
  methods: {
    ...mapActions(['GET_ALL', 'GET_ROLES', 'SAVE']),
    userDelete: function (index, email) {
      let usersData = Object.assign({}, this.FOR_SAVE_USERS);
      if (this.USERS_DATA[index].id != undefined) {
        usersData[email + '_delete'] = {id: this.USERS_DATA[index].id, action: 'delete'};
      } else {
        delete usersData[email];
      }
      this.$store.commit('users/users/FOR_SAVE_USERS', usersData);
      this.USERS_DATA.splice(index, 1);
    },
    addUser: function () {
      for (let key in this.USERS_DATA) {
        if (this.USERS_DATA[key].email == this.email) {
          this.duplicateValue = this.email;
          this.$bvModal.show('usersDuplicateError')
          return
        }
        if (this.USERS_DATA[key].login == this.login) {
          this.duplicateValue = this.login;
          this.$bvModal.show('usersDuplicateError')
          return
        }
      }
      // password generator function
      let generatePassword = function () {
        var length = 8,
            charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
            retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
          retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
      }

      let userData = {
        name: this.name,
        secondName: this.secondName,
        position: this.position,
        email: this.email,
        login: this.login,
        password: generatePassword(),
        roles: this.rolesVal,
        action: '',
      };
      // clear
      this.name = '';
      this.secondName = '';
      this.position = '';
      this.email = '';
      this.login = '';
      this.rolesVal = [];

      this.$root.$emit('bv::toggle::collapse', 'addUser')

      let newUsersData = Object.assign({}, this.FOR_SAVE_USERS);
      newUsersData[userData.email] = userData;
      let usersData = this.USERS_DATA.concat([userData]);

      this.$store.commit('users/users/FOR_SAVE_USERS', newUsersData);
      this.$store.commit('users/users/USERS_DATA', usersData);

      return false;
    },
    editCell: function (index, field) {
      let viewCell = this.$refs.usersTable.$el.querySelectorAll('.t-cell');
      viewCell.forEach((val) => {
        val.style.display = 'inline-block';
      });

      let editCell = this.$refs.usersTable.$el.querySelectorAll('.edit-cell');
      editCell.forEach((val) => {
        val.style.display = 'none';
      })

      this.$refs['cell_view_' + index + '_' + field].style.display = 'none';
      if (this.$refs['cell_edit_' + index + '_' + field].$el == undefined) {
        this.$refs['cell_edit_' + index + '_' + field].style.display = 'block';
      } else {
        this.$refs['cell_edit_' + index + '_' + field].$el.style.display = 'block';
      }
    },
    changeCell: function (index, field) {
      this.$refs['cell_view_' + index + '_' + field].style.display = 'inline-block';

      if (this.$refs['cell_edit_' + index + '_' + field].$el == undefined) {
        this.$refs['cell_edit_' + index + '_' + field].style.display = 'none';
      } else {
        this.$refs['cell_edit_' + index + '_' + field].$el.style.display = 'none';
      }

      let usersData = this.FOR_SAVE_USERS;

      //Если пользователь существует, добавляем его в массив для сохранения
      if ('id' in this.USERS_DATA[index]) {
        usersData[index] = this.USERS_DATA[index]
      }

      this.$store.commit('users/users/FOR_SAVE_USERS', usersData);
    },
    showRole: function (value) {
      let rolesLine = '';
      for (let key in value) {
        for (let key2 in this.ROLES) {
          if (value[key] == this.ROLES[key2].value) {
            if (rolesLine == '') {
              rolesLine = this.ROLES[key2].text;
            } else {
              rolesLine = rolesLine + ', ' + this.ROLES[key2].text;
            }
          }
        }
      }
      return rolesLine;
    }
  },
  computed: {
    ...mapGetters(['USERS_DATA', 'ROLES', 'FOR_SAVE_USERS', 'EDIT_TOGGLE', 'IS_LOAD']),
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('user') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.GET_ROLES();
    this.GET_ALL();
  }
}
</script>

<style scoped>
.add-user {
  text-align: left;
}

.input-add-use {
  margin-top: 0.1em;
}

#users i {
  display: inline-block;
  width: 100%;
  height: 38px;
  vertical-align: middle;
  line-height: 38px;
}

.hide {
  display: none;
}

.show {
  display: block;
}

#users .t-cell {
  overflow: hidden;
}

.cell-cursor {
  cursor: cell;
}
</style>